<template>
  <div class="formDetailReportComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="col-10">
      <div class="ContainerRecordatorio">
        <div class="ContainerRecorda">
          <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
          <p>
            <span>
              {{ $t('report.label.historicMonetization.text') }}
            </span>
          </p>
        </div>
        <v-form ref="formulario" lazy-validation class="mt-5 col-8">
          <div class="formReport">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedStartDate"
                  :label="'*'+$t('report.label.startDate')"
                  color="secondary"
                  :rules="startDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localStartDate"
                color="primary"
                @change="handleStartDateChange"
              ></v-date-picker>
            </v-menu>
  
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedEndDate"
                  :label="'*'+$t('report.label.endDate')"
                  color="secondary"
                  :rules="endDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localEndDate"
                color="primary"
                @change="handleEndDateChange"
                ></v-date-picker>
            </v-menu>

            <v-select
              v-model="formData.redeemType"
              class="redeemTypeSelect"
              :items="redeemTypes"
              :label="$t('report.label.redeemType')"
              item-text="text"
              item-value="value"
              color="secondary"
            ></v-select>
          </div>
        </v-form>
      </div>
    </div>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="submitForm"
          ><v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.download') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import {
  REPORTS_M,
  ACTION_POST_HISTORIC_MONETIZATION,
  ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS,
  GET_JOB_STATUS,
} from "@/views/reports/store/types/types.js";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

export default {
  name: "detailReportComponent",
  props: {
    report: {
      required: true,
    },
  },
  data() {
    return {
      formData: {
        startDate: null,
        endDate: null,
        redeemType: "ALL",
      },
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      formattedStartDate: '',
      formattedEndDate: '',
      loading: false,
      showErrorMessages: false,
      dialog: false,
      processingJob: false,
      jobId: null,
      pollingInterval: null,
      startDateRules: [
        v => !!v || this.$t('report.label.startDate.required'),
      ],
      endDateRules: [
        v => !!v || this.$t('report.label.endDate.required'),
      ],
    };
  },

  computed: {
    ...mapGetters({
      jobStatus: `${REPORTS_M}${GET_JOB_STATUS}`,
    }),

    redeemTypes() {
      return [
        { text: this.$t('report.label.redeemType.all'), value: "ALL" },
        { text: this.$t('report.label.redeemType.library'), value: "LIBRARY" },
        { text: this.$t('report.label.redeemType.report'), value: "REPORTE" },
      ];
    },
  },
  methods: {
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      
      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.formattedStartDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
        icon: "error",
        title: i18n.t('label.date.invalid'),
        text: i18n.t('label.startDate.invalid.text4'),
        });
        this.localStartDate = null;
        this.formattedStartDate = "";
        this.formData.startDate = null;
        return;
      }

      if(this.formData.endDate != null){
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text3'),
          });
          this.localStartDate = null;
          this.formattedStartDate = "";
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.formattedEndDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.localStartDate) {
        Swal.fire({
        icon: "error",
        title: i18n.t('label.date.invalid'),
        text: i18n.t('label.endDate.invalid.text1'),
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
        icon: "error",
        title: i18n.t('label.date.invalid'),
        text: i18n.t('label.endDate.invalid.text3')
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join("<br>");
          Swal.fire({
            icon: "error",
            title: i18n.t('label.errorsValidation.plural.title'),
            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });
          return;
        }

        const body = {
          startDate: this.formData.startDate,
          endDate: this.formData.endDate,
          redeemType: this.formData.redeemType,
        }
        
        const historic = await this.postHistoricMonetization(body);
        
        // Si es 202, hay un job en proceso - iniciar polling
        if (historic.status === 202 && historic.jobId) {
          this.jobId = historic.jobId;
          this.processingJob = true;
          
          Swal.fire({
            title: i18n.t('report.label.processing.title') || 'Procesando...',
            text: i18n.t('report.label.processing.text') || 'Por favor espera mientras se genera el archivo.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          
          this.startPolling();
          return;
        }
        
        // Procesar respuesta normal
        if (historic.data.payload.fileName != null) {
          this.downloadExcelFile(historic.data.payload)
        } else {
          Swal.fire({
          icon: "info",
          title: i18n.t('report.label.downloadExcel.title'),
          text: historic.data.payload.message,
          });
          return;
          }
      } catch (error) {
        console.error(i18n.t('report.label.downloadExcel.error'));
      }
    },

    startPolling() {
      // Polling cada 3 segundos
      this.pollingInterval = setInterval(async () => {
        try {
          await this.getHistoryMonetizationJobStatus(this.jobId);
          
          if (!this.jobStatus) return;
          
          // JobStatus: 0 = Pendiente, 1 = Procesando, 2 = Completado, 3 = Error
          if (this.jobStatus.jobStatus === 2) {
            // Job completado
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            
            Swal.close();
            
            if (this.jobStatus.linkFile) {
              window.open(this.jobStatus.linkFile, "_blank");
            } else if (this.jobStatus.content && this.jobStatus.fileName) {
              // Descargar desde base64 si está disponible
              this.downloadExcelFile(this.jobStatus);
            } else {
              await Swal.fire({
                text: this.jobStatus.message || i18n.t('report.label.downloadExcel.success') || 'Reporte generado exitosamente',
                icon: "success",
                confirmButtonText: i18n.t('button.ok'),
              });
            }
          } else if (this.jobStatus.jobStatus === 3) {
            // Job falló
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            
            Swal.close();
            
            await Swal.fire({
              title: i18n.t('report.label.error.title') || 'Error',
              text: this.jobStatus.errorMessage || i18n.t('report.label.processing.error') || 'Error al generar el reporte',
              icon: "error",
              confirmButtonText: i18n.t('button.ok'),
            });
          }
          // Si es 0 o 1, seguir esperando (no hacer nada)
        } catch (error) {
          console.error('Error en polling:', error);
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          this.processingJob = false;
          
          Swal.close();
          
          await Swal.fire({
            title: i18n.t('report.label.error.title') || 'Error',
            text: i18n.t('report.label.polling.error') || 'Error al consultar el estado del proceso',
            icon: "error",
            confirmButtonText: i18n.t('button.ok'),
          });
        }
      }, 3000); // Cada 3 segundos
    },


    downloadExcelFile(responsePayload) {

      const base64 = responsePayload.content;
      const fileName = responsePayload.fileName;
      const contentType = responsePayload.typeContent;
    
      // Decodificar base64 a binario
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
    
      // Crear Blob
      const blob = new Blob([byteArray], { type: contentType });
    
      // Crear URL y descargar
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
      // Limpiar memoria
      URL.revokeObjectURL(link.href);
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.startDate) {
        errors.startDate = this.$t('report.label.startDate');
      }

      if (!this.formData.endDate) {
        errors.endDate = this.$t('report.label.endDate');
      }
      return errors;
    },

    ...mapActions({
      postHistoricMonetization: `${REPORTS_M}${ACTION_POST_HISTORIC_MONETIZATION}`,
      getHistoryMonetizationJobStatus: `${REPORTS_M}${ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
.formDetailReportComponent {
  display: flex;
  justify-content: center;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.formReport {
  display: flex;
  gap: 60px;
  flex-direction: row;
  justify-content: center;
}

.redeemTypeSelect {
  max-width: 180px;
}

/*Resposive*/

@media screen and (max-width: 768px) {
  .formReport {
    display: flex;
    gap: 40px;
    flex-direction: column;
    justify-content: center;
  }

  .redeemTypeSelect {
    max-width: none;
  }

  p span {
    font-size: 12px;
  }
}

@media screen and (max-width: 425px) {
  .formReport {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
